<template>
  <div id="customer">
    <form @submit.prevent="submit()" autocomplete="off" id="clientForm" v-on:keypress.enter.prevent="enterKey">
      <div class="row mx-1">
        <div class="col-12">
          <h3 class="generalSubtitle">Datos Cliente</h3>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12 col-lg-3 mb-4">
            <div class="generalTitleItemModal">Nombre</div>
            <div>{{ name || '-' }}</div>
        </div>
        <div class="col-12 col-lg-3 mb-4">
            <div class="generalTitleItemModal">Apellidos</div>
            <div>{{ surname1 || '-' }}</div>
        </div>
        <div class="col-12 col-lg-3 mb-4">
            <div class="generalTitleItemModal">Tipo de doc</div>
            <div>{{ documentType || '-' }}</div>
        </div>
        <div class="col-8 col-lg-3 mb-4">
            <div class="generalTitleItemModal">Numero de doc</div>
            <div>{{ documentNumber || '-' }}</div>
        </div>
        <div class="col-12 col-lg-3 mt-4">
            <div class="generalTitleItemModal">Fecha de nacimiento</div>
            <div>{{ $dateBackToFront(birthdate) }}</div>
        </div>
        <div class="col-12 col-lg-3 mt-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="mobile"> Teléfono</label>
            <input type="text" class="form-control generalInput"   id="mobile" maxlength="11"
              v-model.trim.lazy="v$.mobile.$model">
            <div v-if="v$.mobile.$dirty">
              <small class="form-text text-danger" v-if="v$.mobile.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger" v-if="v$.mobile.numeric.$invalid">El
                formato no es correcto</small>
              <small class="form-text text-danger" v-if="v$.mobile.minLength.$invalid">La
                longitud no es correcta</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-3 mt-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="email">Email</label>
            <input type="text" class="form-control generalInput"   id="email"
              v-model.trim.lazy="v$.email.$model" autocomplete="off">
            <div v-if="v$.email.$dirty">
              <small class="form-text text-danger" v-if="v$.email.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger" v-if="v$.email.email.$invalid && !v$.email.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12">
          <h3 class="generalSubtitle">Dirección</h3>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-4 col-lg-2">
          <div class="form-group">
            <label class="generalTitleItemModal" for="streetType"> Tipo de Vía</label>
            <VueNextSelect class="form-control generalInput" id="streetType" :options="tipoDireccion"
              v-model.trim.lazy="v$.streetType.$model" placeholder="" close-on-select></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
            <div v-if="v$.streetType.$dirty">
              <small class="form-text text-danger" v-if="v$.streetType.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
        <div class="col-8 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="street"> Nombre de la vía</label>
            <input type="text" class="form-control generalInput"   id="street"
              v-model.trim.lazy="v$.street.$model">
            <div v-if="v$.street.$dirty">
              <small class="form-text text-danger" v-if="v$.street.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.street.addressCaracters.$invalid && !v$.street.required.$invalid">Formato invalido</small>
            </div>
          </div>
        </div>
        <div class=" col-12 col-lg-6">
          <div class="row">
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal" for="number">Número</label>
                <input type="text" class="form-control generalInput"   id="number"
                  v-model.trim.lazy="v$.number.$model">
                <div v-if="v$.number.$dirty">
                  <small class="form-text text-danger" v-if="v$.number.required.$invalid">Campo requerido</small>
                  <small class="form-text text-danger"
                    v-if="v$.number.addressCaracters.$invalid && !v$.number.required.$invalid">Formato invalido</small>
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal" for="floor">Piso</label>
                <input type="text" class="form-control generalInput"   id="floor"
                  v-model.trim.lazy="v$.floor.$model">
                <div v-if="v$.floor.$dirty">
                  <small class="form-text text-danger" v-if="v$.floor.addressCaracters.$invalid">Formato
                    invalido</small>
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal" for="door">Puerta</label>
                <input type="text" class="form-control generalInput"   id="door"
                  v-model.trim.lazy="v$.door.$model">
                <div v-if="v$.door.$dirty">
                  <small class="form-text text-danger" v-if="v$.door.addressCaracters.$invalid">Formato
                    invalido</small>
                </div>
              </div>
            </div>
            <div class="col-3 col-lg-3">
              <div class="form-group">
                <label class="generalTitleItemModal" for="stair">Escalera</label>
                <input type="text" class="form-control generalInput"   id="stair"
                  v-model.trim.lazy="v$.stair.$model">
                <div v-if="v$.stair.$dirty">
                  <small class="form-text text-danger" v-if="v$.stair.addressCaracters.$invalid">Formato
                    invalido</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="city"> Localidad</label>
            <input type="text" class="form-control generalInput"   id="city"
              v-model.trim.lazy="v$.city.$model">
            <div v-if="v$.city.$dirty">
              <small class="form-text text-danger" v-if="v$.city.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.city.addressCaracters.$invalid && !v$.city.required.$invalid">Formato
                invalido</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="state"> Provincia</label>
            <VueNextSelect class="form-control generalInput" id="state" :options="provincesData"
              v-model.trim.lazy="v$.state.$model" placeholder="" close-on-select></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
            <div v-if="v$.state.$dirty">
              <small class="form-text text-danger" v-if="v$.state.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalTitleItemModal" for="postalCode"> Código Postal</label>
            <input type="text" class="form-control generalInput"   id="postalCode"
              v-model.trim.lazy="v$.postalCode.$model">
            <div v-if="v$.postalCode.$dirty">
              <small class="form-text text-danger" v-if="v$.postalCode.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="sameAddress" v-model.trim.lazy="sameAddress">
            <label class="generalLabel custom-control-label" for="sameAddress">Usar una dirección de facturación
              diferente</label>
          </div>
        </div>
      </div>
      <div v-if="sameAddress">
        <div class="row mx-1">
          <div class="col-12">
            <h3 class="generalSubtitle">Dirección Facturación</h3>
          </div>
        </div>
        <div class="row mx-1">
          <div class="col-4 col-lg-2">
            <div class="form-group">
              <label class="generalTitleItemModal" for="streetTypeB"> Tipo de Vía</label>
              <VueNextSelect class="form-control generalInput" id="streetTypeB" :options="tipoDireccion"
                v-model.trim.lazy="v$.streetTypeB.$model" placeholder="" close-on-select></VueNextSelect>
              <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
              <div v-if="v$.streetTypeB.$dirty">
                <small class="form-text text-danger" v-if="v$.streetTypeB.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class="col-8 col-lg-4">
            <div class="form-group">
              <label class="generalTitleItemModal" for="streetB"> Nombre de la vía</label>
              <input type="text" class="form-control generalInput"   id="streetB"
                v-model.trim.lazy="v$.streetB.$model">
              <div v-if="v$.streetB.$dirty">
                <small class="form-text text-danger" v-if="v$.streetB.required.$invalid">Campo requerido</small>
                <small class="form-text text-danger"
                  v-if="v$.streetB.addressCaracters.$invalid && !v$.streetB.required.$invalid">Formato invalido</small>
              </div>
            </div>
          </div>
          <div class=" col-12 col-lg-6">
            <div class="row">
              <div class="col-3">
                <div class="form-group">
                  <label class="generalTitleItemModal" for="numberB"> Número</label>
                  <input type="text" class="form-control generalInput"   id="numberB"
                    v-model.trim.lazy="v$.numberB.$model">
                  <div v-if="v$.numberB.$dirty">
                    <small class="form-text text-danger" v-if="v$.numberB.required.$invalid">Campo requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.numberB.addressCaracters.$invalid && !v$.numberB.required.$invalid">Formato
                      invalido</small>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="generalTitleItemModal" for="floorB">Piso</label>
                  <input type="text" class="form-control generalInput"   id="floorB"
                    v-model.trim.lazy="v$.floorB.$model">
                  <div v-if="v$.floorB.$dirty">
                    <small class="form-text text-danger" v-if="v$.floorB.addressCaracters.$invalid">Formato
                      invalido</small>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="generalTitleItemModal" for="doorB">Puerta</label>
                  <input type="text" class="form-control generalInput"   id="doorB"
                    v-model.trim.lazy="v$.doorB.$model">
                  <div v-if="v$.doorB.$dirty">
                    <small class="form-text text-danger" v-if="v$.doorB.addressCaracters.$invalid">Formato
                      invalido</small>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <div class="form-group">
                  <label class="generalTitleItemModal" for="stairB">Escalera</label>
                  <input type="text" class="form-control generalInput"   id="stairB"
                    v-model.trim.lazy="v$.stairB.$model">
                  <div v-if="v$.postalCodeB.$dirty">
                    <small class="form-text text-danger" v-if="v$.postalCodeB.addressCaracters.$invalid">Formato
                      invalido</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <label class="generalTitleItemModal" for="cityB"> Localidad</label>
              <input type="text" class="form-control generalInput"   id="cityB"
                v-model.trim.lazy="v$.cityB.$model">
              <div v-if="v$.cityB.$dirty">
                <small class="form-text text-danger" v-if="v$.cityB.required.$invalid">Campo requerido</small>
                <small class="form-text text-danger"
                  v-if="v$.cityB.addressCaracters.$invalid && !v$.cityB.required.$invalid">Formato invalido</small>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <label class="generalTitleItemModal" for="stateB"> Provincia</label>
              <VueNextSelect class="form-control generalInput" id="stateB" :options="provincesData"
                v-model.trim.lazy="v$.stateB.$model" placeholder="" close-on-select></VueNextSelect>
              <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
              <div v-if="v$.stateB.$dirty">
                <small class="form-text text-danger" v-if="v$.stateB.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
          <div class=" col-12 col-lg-4">
            <div class="form-group mb-0">
              <label class="generalTitleItemModal" for="postalCodeB"> Código Postal</label>
              <input type="text" class="form-control generalInput"   id="postalCodeB"
                v-model.trim.lazy="v$.postalCodeB.$model">
              <div v-if="v$.postalCodeB.$dirty">
                <small class="form-text text-danger" v-if="v$.postalCodeB.required.$invalid">Campo requerido</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4 mx-1">
        <div class="col-12">
          <button class="btn btn-outline-secondary float-left generalSecondaryButton"
            @click="goBack($event)">Atrás</button>
          <button class="btn btn-primary float-right generalPrimaryButton" id="submitButton"
            v-bind:class="{ disabled: v$.$invalid }" :disabled="v$.$invalid">Continuar</button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import useVuelidate from '@vuelidate/core';
import provincias from '../../../../../data/provinces.json'
import {
  required,
  email,
  numeric,
  minLength,
  requiredIf,
} from '@vuelidate/validators'
import VueNextSelect from 'vue-next-select'

const addressCaracters = (value) => {
  if (/[$%&|<>#=¿?¡!@~¬/{}[-_()*+´¨`^¢,:;\]\\·"'€]/gi.test(value))
    return false
  else return true
}

export default {
  name: 'customer',
  setup() {
    return { v$: useVuelidate() }
  },
  components: {
    VueNextSelect
  },
  data() {
    return {
      name: this.$store.state.newContractData.customer.name,
      surname1: this.$store.state.newContractData.customer.surnames,
      documentType: this.$store.state.newContractData.customer.documentType || 'DNI',
      documentNumber: this.$store.state.newContractData.customer.legalIdentifier,
      mobile: this.$store.state.newContractData.customer.mobile,
      birthdate: this.$store.state.newContractData.customer.birthdate,
      trustworthy: this.$store.state.newContractData.customer.trustworthy,
      email: this.$store.state.newContractData.customer.email,
      streetType: this.$store.state.newContractData.customer.deliveryAddress.streetType || 'Calle',
      street: this.$store.state.newContractData.customer.deliveryAddress.street,
      number: this.$store.state.newContractData.customer.deliveryAddress.number,
      floor: this.$store.state.newContractData.customer.deliveryAddress.floor,
      door: this.$store.state.newContractData.customer.deliveryAddress.door,
      stair: this.$store.state.newContractData.customer.deliveryAddress.stair,
      postalCode: this.$store.state.newContractData.customer.deliveryAddress.postalCode,
      city: this.$store.state.newContractData.customer.deliveryAddress.city,
      country: this.$store.state.newContractData.customer.deliveryAddress.country,
      state: this.$store.state.newContractData.customer.deliveryAddress.province,
      sameAddress: this.$store.state.newContractData.customer.billingAddress.sameAddress || false,
      streetTypeB: this.$store.state.newContractData.customer.billingAddress.streetType || 'Calle',
      streetB: this.$store.state.newContractData.customer.billingAddress.street,
      numberB: this.$store.state.newContractData.customer.billingAddress.number,
      floorB: this.$store.state.newContractData.customer.billingAddress.floor,
      doorB: this.$store.state.newContractData.customer.billingAddress.door,
      stairB: this.$store.state.newContractData.customer.billingAddress.stair,
      postalCodeB: this.$store.state.newContractData.customer.billingAddress.postalCode,
      cityB: this.$store.state.newContractData.customer.billingAddress.city,
      countryB: this.$store.state.newContractData.customer.billingAddress.country,
      stateB: this.$store.state.newContractData.customer.billingAddress.province,
      disabledDates: {
        from: new Date(),
      },
      modelConfig: {
        type: 'string',
        mask: 'DD/MM/YYYY',
      },
      provincesData: provincias,
      tipoDocumento: ['DNI', 'CIF', 'NIE'],
      tipoDireccion: ['Calle', 'Avenida', 'Plaza', 'Carretera', 'Travesía'],
    };
  },
  validations() {
    return {
      mobile: {
        required,
        numeric,
        minLength: minLength(9),
      },
      email: {
        required,
        email,
      },
      streetType: {
        required,
      },
      street: {
        required,
        addressCaracters
      },
      number: {
        required,
        addressCaracters
      },
      floor: {
        addressCaracters
      },
      door: {
        addressCaracters
      },
      stair: {
        addressCaracters
      },
      postalCode: {
        required,
      },
      city: {
        required,
        addressCaracters
      },
      state: {
        required,
      },
      streetTypeB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
      },
      streetB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
        addressCaracters
      },
      numberB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
        addressCaracters
      },
      floorB: {
        addressCaracters
      },
      doorB: {
        addressCaracters
      },
      stairB: {
        addressCaracters
      },
      postalCodeB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
        addressCaracters
      },
      cityB: {
        required: requiredIf(function () {
          return this.sameAddress;
        }),
        addressCaracters
      },
      stateB: {
        required: requiredIf(function () {
          return this.sameAddress;
        })
      }
    }
  },
  computed: {
    disabled24Years() {
      // `this` apunta a la instancia vm
      let eighteenYearsAgo = this.disabledDates.from.setFullYear(this.disabledDates.from.getFullYear() - 24);
      eighteenYearsAgo = new Date(eighteenYearsAgo);
      return eighteenYearsAgo;
    },
  },
  methods: {
    submit() {
      this.$store.commit('setLoading', true);
      var bodyToSave = '';
      bodyToSave = {
        name: this.name.trim(),
        surname1: this.surname1,
        legalIdentifier: this.documentNumber.trim(),
        mobile: this.mobile,
        birthdate: this.birthdate,
        email: this.email.trim(),
        language: '',
        documentType: this.documentType,
        trustworthy: this.trustworthy
      };
      bodyToSave.deliveryAddress = {
        street: this.street.trim(),
        number: this.number.trim(),
        floor: this.floor ? this.floor.trim() : '',
        door: this.door ? this.door.trim() : '',
        stair: this.stair ? this.stair.trim() : '',
        postalCode: this.postalCode.trim(),
        city: this.city,
        country: 'España',
        province: this.state.trim(),
        streetType: this.streetType,
      }
      bodyToSave.billingAddress = {
        sameAddress: this.sameAddress,
        street: !this.sameAddress ? this.street.trim() : this.streetB.trim(),
        number: !this.sameAddress ? this.number.trim() : this.numberB.trim(),
        floor: !this.sameAddress ? (this.floor ? this.floor.trim() : '') : (this.floorB ? this.floorB.trim() : ''),
        door: !this.sameAddress ? (this.door ? this.door.trim() : '') : (this.doorB ? this.doorB.trim() : ''),
        stair: !this.sameAddress ? (this.stair ? this.stair.trim() : '') : (this.stairB ? this.stairB.trim() : ''),
        postalCode: !this.sameAddress ? this.postalCode.trim() : this.postalCodeB.trim(),
        city: !this.sameAddress ? this.city : this.cityB,
        country: 'España',
        province: !this.sameAddress ? this.state.trim() : this.stateB.trim(),
        streetType: !this.sameAddress ? this.streetType : this.streetTypeB
      }
      this.$store.commit('setNewContractDataCustomer', bodyToSave);
      this.$router.push({ name: 'renewContractStep3' })
    },
    enterKey: function (e) {
      if (e.keyCode === 13) {
        if (!document.getElementById('submitButton').classList.contains('disabled')) {
          this.submit();
        }
      }
    },
    goBack(event) {
      event.preventDefault();
      this.$router.push({ name: 'renewContractStep1' })
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">// @import 'v-calendar/dist/style.css';</style>